import React, { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const History = ({ viewall, need, heading, travelData, handleDownloadCSV, dropdownOptions, selectedOption, handleOptionChange }) => {
    const navigate = useNavigate();
    const formatDueDate = (date) => {
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();
        return `${month}/${day}/${year}`;
    };
    return (
        <div className="min-w-full container mx-auto bg-white shadow-md rounded-lg">
            <div className="bg-white rounded-t-lg p-4 flex md:flex-row sm:flex-col space-y-4 sm:space-y-0 sm:space-x-0 md:space-x-6 items-center self-center">
                <div className="relative md:w-4/6 sm:w-full mb-[15px] md:mb-0">
                    <h2 className="text-xl font-semibold text-left">{heading}</h2>
                </div>
                {need ?
                    <div className="md:mt-0 md:w-3/6 sm:w-full flex sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
                        <select
                            value={selectedOption}
                            onChange={handleOptionChange}
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full sm:w-3/6"
                        >
                            <option value="">Select days</option>
                            {dropdownOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>

                        <button
                            onClick={handleDownloadCSV}
                            className="p-2 bg-gray-200 rounded-md flex items-center space-x-1 w-full sm:w-3/6 justify-center"
                        >
                            <span>Download CSV</span>
                            <FiDownload className="w-4 h-4" />
                        </button>
                    </div>
                    : null}
            </div>
            <div className="overflow-x-auto bg-white rounded-b-lg">
                <table className="min-w-full overflow-hidden">
                    <thead className="bg-gray-100">
                        <tr className="bg-gray-100 text-left">
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[150px]">Purpose of Travel</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">From</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[150px]">To</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Distance Driven (km)</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Time Spent</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Date</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm text-gray-800">
                        {
                            travelData.length > 3 && viewall === true ?
                                travelData?.slice(0, 3).map((row, idx) => (
                                    <tr key={idx} className="border-b last:border-none">
                                        <td className="p-4 text-gray-800">{row.purpose}</td>
                                        <td className="p-4 text-gray-800">{row.startLocation.length > 25 ? row.startLocation.slice(0, 25) + '...' : row.startLocation}</td>
                                        <td className="p-4 text-gray-800">{row.destination.length > 25 ? row.destination.slice(0, 25) + '...' : row.destination}</td>
                                        <td className="p-4 text-gray-800">{row?.distance} km</td>
                                        <td className="p-4 text-gray-800">{row?.duration} mins</td>
                                        <td className="p-4 text-gray-800">{formatDueDate(row.scheduledDate)}</td>
                                    </tr>
                                ))
                                :

                                travelData.map((row, idx) => (
                                    <tr key={idx} className="border-b last:border-none">
                                        <td className="p-4 text-gray-800">{row.purpose}</td>
                                        <td className="p-4 text-gray-800">{row.startLocation.length > 25 ? row.startLocation.slice(0, 25) + '...' : row.startLocation}</td>
                                        <td className="p-4 text-gray-800">{row.destination.length > 25 ? row.destination.slice(0, 25) + '...' : row.destination}</td>
                                        <td className="p-4 text-gray-800">{row?.distance} km</td>
                                        <td className="p-4 text-gray-800">{row?.duration} mins</td>
                                        <td className="p-4 text-gray-800">{formatDueDate(row.scheduledDate)}</td>
                                    </tr>
                                ))}
                    </tbody>
                </table>
            </div>
            {travelData.length == 0 ?
                <p className="p-4 text-gray-800 text-center">No any travel history found</p>
                : null}
            {viewall && travelData.length > 3 ?
                <div className="p-4 py-6 flex justify-end">
                    <a onClick={() => {
                        navigate('/travel-history', {
                            state: { travelData: travelData },
                        });

                    }} className="text-sm text-black flex items-center">
                        View All <FaChevronRight className="ml-1" />
                    </a>
                </div>
                :
                <div className=" pb-2">
                </div>
            }
        </div>
    );
};

export default History;

// import React, { useState } from 'react';
// import { FaChevronRight } from 'react-icons/fa';
// import { FiDownload } from 'react-icons/fi';
// import { useNavigate } from 'react-router-dom';
// import { subscriptionsCondition } from '../../Reducers/reducers';
// import { useSelector } from 'react-redux';

// const History = ({ viewall, need, heading, travelData, handleDownloadCSV, dropdownOptions, selectedOption, handleOptionChange }) => {
//     const navigate = useNavigate();
//     const { loginData, } = useSelector((state) => state.userReducer);
//     const formatDueDate = (date) => {
//         const d = new Date(date);
//         const month = String(d.getMonth() + 1).padStart(2, "0");
//         const day = String(d.getDate()).padStart(2, "0");
//         const year = d.getFullYear();
//         return `${month}/${day}/${year}`;
//     };
//     return (
//         <div className="min-w-full container mx-auto bg-white shadow-md rounded-lg">
//             <div className="bg-white rounded-t-lg p-4 flex md:flex-row sm:flex-col space-y-4 sm:space-y-0 sm:space-x-0 md:space-x-6 items-center self-center">
//                 <div className="relative md:w-4/6 sm:w-full mb-[15px] md:mb-0">
//                     <h2 className="text-xl font-semibold text-left">{heading}</h2>
//                 </div>
//                 {need ?
//                     <div className="md:mt-0 md:w-3/6 sm:w-full flex sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
//                         <select
//                             value={selectedOption}
//                             onChange={handleOptionChange}
//                             className="border border-gray-300 rounded-lg px-4 py-2 w-full sm:w-3/6"
//                         >
//                             <option value="">Select days</option>
//                             {dropdownOptions.map(option => (
//                                 <option key={option.value} value={option.value}>
//                                     {option.label}
//                                 </option>
//                             ))}
//                         </select>

//                         <button
//                             onClick={handleDownloadCSV}
//                             className="p-2 bg-gray-200 rounded-md flex items-center space-x-1 w-full sm:w-3/6 justify-center"
//                         >
//                             <span>Download CSV</span>
//                             <FiDownload className="w-4 h-4" />
//                         </button>
//                     </div>
//                     : null}
//             </div>
//             <div className="overflow-x-auto bg-white rounded-b-lg">
//                 <table className="min-w-full overflow-hidden">
//                     <thead className="bg-gray-100">
//                         <tr className="bg-gray-100 text-left">
//                             <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[150px]">Purpose of Travel</th>
//                             <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">From</th>
//                             <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[150px]">To</th>
//                             <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Distance Driven (km)</th>
//                             <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Time Spent</th>
//                             <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Date</th>
//                         </tr>
//                     </thead>
//                     <tbody className="text-sm text-gray-800">
//                         {
//                             travelData.length > 3 && viewall == true ?
//                                 travelData?.slice(0, 3).map((row, idx) => (
//                                     <tr key={idx} className="border-b last:border-none">
//                                         <td className="p-4 text-gray-800">{row.purpose}</td>
//                                         <td className="p-4 text-gray-800">{row.startLocation.length > 25 ? row.startLocation.slice(0, 25) + '...' : row.startLocation}</td>
//                                         <td className="p-4 text-gray-800">{row.destination.length > 25 ? row.destination.slice(0, 25) + '...' : row.destination}</td>
//                                         <td className="p-4 text-gray-800">{row?.distance} km</td>
//                                         <td className="p-4 text-gray-800">{row?.duration} mins</td>
//                                         <td className="p-4 text-gray-800">{formatDueDate(row.scheduledDate)}</td>
//                                     </tr>
//                                 ))
//                                 : (
//                                     loginData?.clientData?.subscriptionType == 'Free Forever' ? (
//                                         travelData.length >= 5 ? (
//                                             travelData?.slice(0, 5).map((row, idx) => (
//                                                 <tr key={idx} className="border-b last:border-none">
//                                                     <td className="p-4 text-gray-800">{row.purpose}</td>
//                                                     <td className="p-4 text-gray-800">{row.startLocation.length > 25 ? row.startLocation.slice(0, 25) + '...' : row.startLocation}</td>
//                                                     <td className="p-4 text-gray-800">{row.destination.length > 25 ? row.destination.slice(0, 25) + '...' : row.destination}</td>
//                                                     <td className="p-4 text-gray-800">{row?.distance} km</td>
//                                                     <td className="p-4 text-gray-800">{row?.duration} mins</td>
//                                                     <td className="p-4 text-gray-800">{formatDueDate(row.scheduledDate)}</td>
//                                                 </tr>
//                                             ))
//                                         ) : (
//                                             travelData?.map((row, idx) => (
//                                                 <tr key={idx} className="border-b last:border-none">
//                                                     <td className="p-4 text-gray-800">{row.purpose}</td>
//                                                     <td className="p-4 text-gray-800">{row.startLocation.length > 25 ? row.startLocation.slice(0, 25) + '...' : row.startLocation}</td>
//                                                     <td className="p-4 text-gray-800">{row.destination.length > 25 ? row.destination.slice(0, 25) + '...' : row.destination}</td>
//                                                     <td className="p-4 text-gray-800">{row?.distance} km</td>
//                                                     <td className="p-4 text-gray-800">{row?.duration} mins</td>
//                                                     <td className="p-4 text-gray-800">{formatDueDate(row.scheduledDate)}</td>
//                                                 </tr>
//                                             ))
//                                         ))
//                                         : loginData?.clientData?.subscriptionType == 'Repotal Pro' ? (
//                                             travelData.length >= 100 ? (
//                                                 travelData?.slice(0, 100).map((row, idx) => (
//                                                     <tr key={idx} className="border-b last:border-none">
//                                                         <td className="p-4 text-gray-800">{row.purpose}</td>
//                                                         <td className="p-4 text-gray-800">{row.startLocation.length > 25 ? row.startLocation.slice(0, 25) + '...' : row.startLocation}</td>
//                                                         <td className="p-4 text-gray-800">{row.destination.length > 25 ? row.destination.slice(0, 25) + '...' : row.destination}</td>
//                                                         <td className="p-4 text-gray-800">{row?.distance} km</td>
//                                                         <td className="p-4 text-gray-800">{row?.duration} mins</td>
//                                                         <td className="p-4 text-gray-800">{formatDueDate(row.scheduledDate)}</td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 travelData?.map((row, idx) => (
//                                                     <tr key={idx} className="border-b last:border-none">
//                                                         <td className="p-4 text-gray-800">{row.purpose}</td>
//                                                         <td className="p-4 text-gray-800">{row.startLocation.length > 25 ? row.startLocation.slice(0, 25) + '...' : row.startLocation}</td>
//                                                         <td className="p-4 text-gray-800">{row.destination.length > 25 ? row.destination.slice(0, 25) + '...' : row.destination}</td>
//                                                         <td className="p-4 text-gray-800">{row?.distance} km</td>
//                                                         <td className="p-4 text-gray-800">{row?.duration} mins</td>
//                                                         <td className="p-4 text-gray-800">{formatDueDate(row.scheduledDate)}</td>
//                                                     </tr>
//                                                 ))
//                                             ))
//                                             : loginData?.clientData?.subscriptionType == 'Repotal Ultimate' ? (
//                                                 travelData?.map((row, idx) => (
//                                                     <tr key={idx} className="border-b last:border-none">
//                                                         <td className="p-4 text-gray-800">{row.purpose}</td>
//                                                         <td className="p-4 text-gray-800">{row.startLocation.length > 25 ? row.startLocation.slice(0, 25) + '...' : row.startLocation}</td>
//                                                         <td className="p-4 text-gray-800">{row.destination.length > 25 ? row.destination.slice(0, 25) + '...' : row.destination}</td>
//                                                         <td className="p-4 text-gray-800">{row?.distance} km</td>
//                                                         <td className="p-4 text-gray-800">{row?.duration} mins</td>
//                                                         <td className="p-4 text-gray-800">{formatDueDate(row.scheduledDate)}</td>
//                                                     </tr>
//                                                 )))
//                                                 : null)}
//                     </tbody>
//                 </table>
//             </div>
//             {travelData.length == 0 ?
//                 <p className="p-4 text-gray-800 text-center">No any travel history found</p>
//                 : null}
//             {viewall && travelData.length > 3 ?
//                 <div className="p-4 py-6 flex justify-end">
//                     <a onClick={() => {
//                         navigate('/travel-history', {
//                             state: { travelData: travelData },
//                         });

//                     }} className="text-sm text-black flex items-center">
//                         View All <FaChevronRight className="ml-1" />
//                     </a>
//                 </div>
//                 :
//                 <div className=" pb-2">
//                 </div>
//             }
//         </div>
//     );
// };

// export default History;
